<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  score: {
    type: Number,
    required: true,
  },
});

const { t } = useI18n();

const level = computed(() => {
  if (props.score < 40) return 'weak';
  if (props.score < 65) return 'fair';
  if (props.score < 85) return 'good';
  return 'excellent';
});

const barClass = computed(() => {
  switch (level.value) {
    case 'weak':
      return 'bg-n-ruby-9';
    case 'fair':
      return 'bg-n-amber-9';
    case 'good':
      return 'bg-n-blue-9';
    default:
      return 'bg-n-teal-9';
  }
});
</script>

<template>
  <div
    class="flex flex-col w-36 gap-1"
    :title="t('WGPT_CAR_LISTINGS.EDITOR.STRENGTH.LABEL')"
  >
    <div class="flex items-center justify-between">
      <span class="text-xs text-n-slate-11">
        {{ t(`WGPT_CAR_LISTINGS.EDITOR.STRENGTH.LEVELS.${level}`) }}
      </span>
      <span class="text-xs font-medium text-n-slate-12">{{ score }}%</span>
    </div>
    <div class="h-1.5 overflow-hidden rounded-full bg-n-alpha-2">
      <div
        class="h-full transition-all duration-300 rounded-full"
        :class="barClass"
        :style="{ width: `${Math.min(score, 100)}%` }"
      />
    </div>
  </div>
</template>
